import { useState, useEffect } from "react";
import {
  getDrinks,
  createDrink,
  updateDrink,
  deleteDrink,
} from "../../api/drinkApi";
import { GeneralService } from "../services/GeneralService";
import { notify } from "../components/Customs/NotifyProvider";

const useDrink = () => {
  const [drinks, setDrinks] = useState([]);
  const [loading, setLoading] = useState(false);

  const [cat, setCat] = useState([]);

  // ================= FETCH =================
  const fetchDrinks = async () => {
    try {
      setLoading(true);
      const res = await getDrinks();
      setDrinks(res.data);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const data = await GeneralService.get("drink_category");
      setCat(Array.isArray(data?.data) ? data.data : []);
    } catch (err) {
      console.error("Category fetch error:", err);
      setCat([]);
    }
  };

  useEffect(() => {
    fetchDrinks();
    fetchCategories();
  }, []);

  // ================= CREATE =================
  const handleCreateDrink = async (data) => {
    try {
      await createDrink(data);
      notify.success("Drink created successfully");
      fetchDrinks();
    } catch (err) {
      notify.error(err?.response?.data?.message || "Failed to create drink");
      console.error("Create error:", err);
    }
  };

  // ================= UPDATE =================
  const handleUpdateDrink = async (id, data) => {
    try {
      await updateDrink(id, data);
      notify.success("Drink updated successfully");
      fetchDrinks();
    } catch (err) {
      notify.error(err?.response?.data?.message || "Failed to update drink");
      console.error("Update error:", err);
    }
  };

  // ================= DELETE =================
  const handleDeleteDrink = async (id) => {
    try {
      await deleteDrink(id);
      notify.success("Drink deleted successfully");
      fetchDrinks();
    } catch (err) {
      notify.error(err?.response?.data?.message || "Failed to delete drink");
      console.error("Delete error:", err);
    }
  };

  return {
    drinks,
    loading,
    fetchDrinks,
    createDrink: handleCreateDrink,
    updateDrink: handleUpdateDrink,
    deleteDrink: handleDeleteDrink,
    cat, // you can replace with API later
  };
};

export default useDrink;
